<div class="form-card form-card-large" [formGroup]="marketingConsentForm">
  <h2 class="form-title">
    <span class="icon"></span>
    Préférences de communication
  </h2>
  <p>Souhaitez-vous recevoir des communications de la part de Castorama afin de profiter de réductions / promotions dédiées aux adhérents fidélités, d’invitations à des événements privés et, plus largement, toute communication à portée commerciale de la part de Castorama  France ?</p>
  <div class="form-group mt-3">
    <div class="form-row">
      <div class="form-col">
        <div class="form-check form-switch">
          <label class="form-check-label" for="optinEmail">Email</label>
          <input class="form-check-input"
                 type="checkbox"
                 role="switch"
                 id="optinEmail"
                 formControlName="optinEmail"
                 [defaultChecked]="true">
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-col">
        <div class="form-check form-switch">
          <label class="form-check-label" for="optinSms">Sms</label>
          <input class="form-check-input"
                 type="checkbox"
                 role="switch"
                 id="optinSms"
                 formControlName="optinSms"
                 [defaultChecked]="false">
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-col">
        <div class="form-check form-switch">
          <label class="form-check-label" for="optinPhone">Appel</label>
          <input class="form-check-input"
                 type="checkbox"
                 role="switch"
                 id="optinPhone"
                 formControlName="optinPhone"
                 [defaultChecked]="false">
        </div>
      </div>
    </div>
    <div class="form-row form-inline">
      <input type="checkbox"
             id="optoutPostal"
             formControlName="optoutPostal"
             [defaultChecked]="false">
      <label for="optoutPostal">
        Je ne souhaite pas recevoir de communications concernant des promotions ou des opérations commerciales par courrier postal de la part de Castorama
      </label>
    </div>
  </div>
</div>
